import React from 'react';

export function StudyCard({ reference = '', verse = null, insight = null, book = null }) {
  return (
    <div style={{ margin: '10px 0 14px', padding: '14px 16px', background: 'rgba(6,14,40,0.55)', border: '1px solid rgba(251,191,36,0.15)', borderRadius: 12, fontFamily: 'inherit' }}>
      <span style={{ fontSize: 9.5, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(251,191,36,0.55)', display: 'block', marginBottom: 10 }}>
        {book || 'Estudo Bíblico'}
      </span>

      {/* Reference */}
      <div style={{ fontSize: 14, fontWeight: 600, color: '#fbbf24', marginBottom: verse ? 10 : 0 }}>
        {reference}
      </div>

      {/* Verse */}
      {verse && (
        <div style={{
          fontSize: 13, color: 'rgba(220,228,255,0.82)',
          lineHeight: 1.65, fontStyle: 'italic',
          borderLeft: '2px solid rgba(251,191,36,0.3)',
          paddingLeft: 12, marginBottom: insight ? 10 : 0,
        }}>
          "{verse}"
        </div>
      )}

      {/* Insight */}
      {insight && (
        <div style={{ background: 'rgba(251,191,36,0.05)', border: '1px solid rgba(251,191,36,0.12)', borderRadius: 7, padding: '8px 12px' }}>
          <span style={{ fontSize: 10, color: 'rgba(251,191,36,0.6)', fontWeight: 600 }}>💡 REFLEXÃO · </span>
          <span style={{ fontSize: 12, color: 'rgba(172,196,236,0.72)' }}>{insight}</span>
        </div>
      )}
    </div>
  );
}
